import React from 'react';
import { Box, TextField } from '@mui/material';

interface NameGroupValue {
  first_name: string;
  middle_name: string;
  last_name: string;
}

interface Props {
  value: NameGroupValue;
  onChange: (value: NameGroupValue) => void;
}

export default function NameGroupInput({
  value,
  onChange,
}: Props): React.ReactElement {
  const handleChange =
    (field: keyof NameGroupValue) =>
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange({ ...value, [field]: e.target.value });
    };

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}
      data-testid="name-group-input"
    >
      <TextField
        label="First name *"
        value={value.first_name || ''}
        onChange={handleChange('first_name')}
        fullWidth
        required
        inputProps={{ 'data-testid': 'first-name-input' }}
      />
      <TextField
        label="Middle name"
        value={value.middle_name || ''}
        onChange={handleChange('middle_name')}
        fullWidth
        inputProps={{ 'data-testid': 'middle-name-input' }}
      />
      <TextField
        label="Last name *"
        value={value.last_name || ''}
        onChange={handleChange('last_name')}
        fullWidth
        required
        inputProps={{ 'data-testid': 'last-name-input' }}
      />
    </Box>
  );
}
